<template>
	<div class>
		<ModalBox v-model="legacyModalVisible" placement="right" size="sm" scroll-body hide-close header-class="!hidden">

			<!-- stream types -->
			<div class="modal-container">
				<div class="px-3 mb-2 mt-100 mobile-header flex flex-wrap items-center">
					<div class="w-2/3">
						<router-link :to="{ path: '/dashboard' }" class="modal-logo">
							<img height="32px" class="logo-icon" :src="require('@/assets/castr.svg')" alt="Streaming Dashboard - Castr"   />
							<div class="logo-icon-dot" />
						</router-link>
						<h3 class="text-s-m block md:hidden">
							Create New
						</h3>
					</div>
					<div class="text-right w-1/3">
						<FormButton type="light" :isIcon="true" class="px-2 btn-close" @click="dismiss">
							<img :src="require('@/assets/images/menu-close.svg')" alt="Menu close">
						</FormButton>
					</div>
				</div>
				<div class="flex flex-wrap">
					<div class="w-full">
						<h3 class="text-s-m ml-4 mt-5 !mb-4">
							Sub Second Streaming
						</h3>
						<p class="ml-4 text-s-s text-dark-8">Stream in real time with ultra-low latency for interactive experiences.</p>
						<div>
							<div v-if="error">
								<div v-if="error.role">
									<div class="bg-dark-3 flex flex-wrap gap-0">
										<div class="p-3 w-full">
											<p class="mb-2">
												You do not have an active {{ (selectedStreamType === 'restream') ? 'Multistream' :
													(selectedStreamType !== 'vod' ? ' Live Stream' : '') }} subscription.</p>
											<p class="mb-0 text-s-m text-dark-7">Would you like to activate our 7-day trial?</p>
										</div>
									</div>

									<div v-if="trialError" class="alert alert-danger">{{ trialError.message }}</div>
									<div class="text-right">
										<div v-if="trialProcessing">
											<FormProgress :value="100" :max="100" animated class="w-full" />
										</div>
										<div v-else>
											<div class="flex flex-wrap">
												<div class="px-5 mt-4 w-full">
													<FormButton :disabled="trialProcessing" type="main" size="md" fullWidth class="justify-center mb-3"
														@click="forceActivateTrial"><span v-if="!trialProcessing">Activate Trial</span><span
															v-else>Activating... Please wait</span></FormButton>
													<FormButton type="link" size="md" fullWidth class="justify-center text-dark-7 mb-3"
														:to="`/subscribe?category=${selectedStreamType}`">
														Want more options?
													</FormButton>
													<FormButton type="secondary" fullWidth class="justify-center" size="md" @click="dismiss">Cancel</FormButton>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- form -->
							<div class="mt-5">
								<div class="flex flex-wrap">
									<div class="w-full">
										<Alert v-if="error && !error.role" type="error" class="text-left mx-4">
											<div v-html="error.message"></div>
											<div v-if="error.subscription" class="text-left">
												<a href="/app/subscribe"><strong>upgrade now</strong></a>
											</div>
										</Alert>
									</div>
								</div>
								<div class="flex flex-wrap" no-gutters>
									<div class="px-4 py-2 w-full">
										<label class="block mb-1 text-sm text-surface-8">
											Stream name
										</label>
										<FormInput v-model="channel.name" size="md" placeholder="Enter your stream name"
											@keypress="onInputChange('name')" />
										<p v-show="formErrors.name" class="text-warning pl-1">
											Please enter a stream name.
										</p>
									</div>
								</div>
								<div class="flex flex-wrap" no-gutters>
									<div class="px-4 py-2 w-full">
										<label class="block mb-1 text-sm text-surface-8">
											Ingest region
										</label>
										<StreamRegion class="relative" :stream="channel" @switch-stream-region="changeRegion" />
										<p class="text-tiny text-surface-7 mt-1 mb-0">Choose the region closest to your encoder for the best ingest quality.</p>
										<p v-show="formErrors.region" class="text-warning pl-1">
											Please choose a region.
										</p>
									</div>
								</div>
								<div class="flex flex-wrap" no-gutters>
									<div class="px-4 w-full" v-show="operational || processing">
										<FormButton type="main" size="md" class="w-full mt-3" disabled v-if="processing">
											<Spinner text="Creating..." classes="text-dark-8" spinner-color="var(--c-dark-8)"
												spinner-size="15px" />
										</FormButton>
										<div v-else class="w-full">
											<FormButton :disabled="isDisabled" type="main" size="md" fullWidth class="justify-center" @click="onSaveChannel">
												<!-- Create {{ selectedStreamType === 'vod' ? 'Bucket' : 'Stream' }} -->
												Create Sub Second Stream
											</FormButton>
											<div class="mt-2">
												<FormButton type="secondary" size="md" @click="dismiss"
													fullWidth class="justify-center mb-3 md:mb-0">
													Cancel
												</FormButton>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <br> -->
						</div>
					</div>
				</div>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import FormProgress from '@/components/Atoms/FormProgress.vue'
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import _ from 'lodash';
import Spinner from "@/components/ui/Spinner.vue";
import StreamService from '@/services/StreamService';
import IconBase from '@/components/icon/IconBase.vue';
import IconChevronUpDown from '@/components/icon/IconChevronUpDown.vue';
import IconLivestream from '@/components/icon/IconLivestream.vue';
import IconMultistream from '@/components/icon/IconMultistream.vue';
import IconIpcam from '@/components/icon/IconIpcam.vue';
import IconSchedulestream from '@/components/icon/IconSchedulestream.vue';
import IconVodChannel from '@/components/icon/IconVodChannel.vue';
import SubscriptionService from '@/services/SubscriptionService';
import StreamRegion from '../ui/StreamRegion.vue';
import FormButton from '@/components/Atoms/FormButton.vue';
import Alert from '@/components/Atoms/Alert.vue';
import FormInput from '@/components/Atoms/FormInput.vue';
import { track, EVENTS } from '@/lib/tracking';

export default {
	name: 'AddSubSecondStreamModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-add-sub-second-stream',
	components: {
		FormProgress,
		ModalBox,
		Alert,
		FormButton,
		FormInput,
		Spinner,
		IconBase,
		IconChevronUpDown,
		IconLivestream,
		IconMultistream,
		IconIpcam,
		IconSchedulestream,
		IconVodChannel,
		StreamRegion
	},
	data() {
		return {
			processing: false,
			trialProcessing: false,
			error: null,
			trialError: null,
			operational: true,
			viewStage: 1,
			selectedStreamType: null,
			userSubscription: null,
			channel: {
				title: null,
				uiRegion: null,
				type: 'subsecond'
			},
			selectedRegion: null,
			regions: [],
			formErrors: { name: false, uiRegion: false },
			onInputChange(prop) {
				this.formErrors[prop] = false;
			}
		};
	},
	props: {
		
	},
	computed: {
		userEmail() {
			return this.$store.state.User.email;
		},
		subscriptions() {
			return this.$store.state.User.subscriptions;
		},
		activeTeam() {
			return this.$store.state.User.activatedTeam;
		},
		memberPermission() {
			return this.activeTeam && this.$store.state.User.memberPermission;
		},
		isDisabled() {
			return !this.channel.name || !this.channel.uiRegion;
		}
	},
	watch: {

	},
	async mounted() {
		// Use Vuex store for regions (already loaded at app level)
		await this.$store.dispatch('Regions/getRegions', 'list');
		this.regions = _.cloneDeep(this.$store.getters['Regions/getRegionsByCategory']('list'));
	},
	methods: {
		// was @shown="checkSelected" on the old b-modal
		onLegacyModalShow() {
			this.checkSelected();
		},
		onDismiss() {
			this.resetForm();
			this.clearErrors();
			// lazy clear
			setTimeout(() => {
				this.processing = false;
			}, 1000);
		},
		dismiss() {
			this.hideLegacyModal();
			this.onDismiss();
		},
		changeRegion(region) {
			this.selectedRegion = region
			this.channel.uiRegion = region;
			this.onInputChange('region')
		},
		getCountryFlag(region) {
			return `https://assets.castr.io/countryflags/${region.identifier}/flat/64.png`;
		},
		async forceActivateTrial() {
			this.trialError = null;
			this.trialProcessing = true;

			// activate trial
			const subCat = this.selectedStreamType;
			try {
				await SubscriptionService.requestTrial(subCat);
				// update vuex state
				await this.$store.dispatch('User/loadUser', null, { root: true });
			} catch (e) {
				this.trialError = e;
				return;
			} finally {
				this.trialProcessing = false;
			}

			this.error = null;
			this.operational = true;

			// on trial activated
			if (!this.trialError) {
				track(EVENTS.TRIAL_STARTED, { packCategory: 'subsecond' });
				this.$notify({
					group: 'success',
					text: `${this.selectedStreamType} trial activated successfully`
				});
			}
		},
		async onSaveChannel() {
			this.error = null;

			if (!this.validateForm()) return;

			this.processing = true;

			try {
				// const stream = await StreamService.addStream(
				const subStream = await StreamService.addStream(
					this.channel.name,
					this.channel.uiRegion._id,
					this.channel.type
				);


				track(EVENTS.STREAM_CREATED, {
					streamType: 'subsecond',
					ingest_protocol: 'whip',
					regionName: this.selectedRegion?.name
				});

				this.$emit('new-channel', subStream, this.selectedRegion);
				await this.$store.dispatch('Streams/getStreams')
				this.dismiss();
			} catch (err) {
				this.error = err;
				this.processing = false;
				this.selectedRegion = null;
				err.message = '<i class="fas fa-exclamation-triangle mr-2"></i>' + err.message;
				// check if subscripiton error
				if (err && _.indexOf(err.message, 'subscription') > -1) {
					this.error.subscription = true;
				}
			}
		},
		validateForm() {
			const props = ['name', 'uiRegion'];

			let valids = 0;
			_.each(props, prop => {
				const val = this.channel[prop];
				if (val) valids++;
				// else this.formErrors[prop] = true;

				this.formErrors[prop] = !val;
			});

			return valids === props.length;
		},
		clearErrors() {
			this.error = null;
			this.formErrors.name = false;
			this.formErrors.region = false;
		},
		resetForm() {
			this.selectedStreamType = null;
			this.channel.name = null;
			// this.channel.region = null;
			// this.selectedRegion = null;
		},
		checkSelected() {
			if (this.typeFromBilling === 'restream' || this.typeFromBilling === 'live') {

				this.selectStreamType(this.typeFromBilling);
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.stream-item {
	padding: 16px 26px;
	position: relative;
	/* margin-bottom: 20px; */
	cursor: pointer;
}

.stream-item__desc {
	position: relative;
	flex-grow: 1;
}

.stream-item:not(:last-child) .stream-item__desc:after {
	content: '';
	display: block;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	height: 1px;
	position: absolute;
	left: 0;
	bottom: -15px;
}

.stream-item:hover {
	background-color: var(--c-dark-3);
}

.stream-item.active {
	background-color: var(--c-main-1);
}

.stream-item.active .stream-item__desc:after {
	content: none;
}

.stream-item svg {
	color: var(--c-main-1);
}

.stream-item:hover svg,
.stream-item.active svg {
	color: #fff;
}

.stream-item.active .stream-item__p {
	color: #fff;
}

.stream-item__title {
	font-size: var(--font-s-m);
}

.stream-item__p {
	font-size: var(--font-s-s);
}

/* .hideform {
		display: none;
	}
	.showform {
		display: flex;
	} */
.second-modal {
	position: fixed;
	top: 0;
	background-color: var(--c-dark-2);
	margin: auto;
	width: 400px;
	height: 100%;
	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, right 0.3s ease-out;
	right: 0;
	z-index: -1;
	border-left: 1px solid var(--c-dark-3);
	border-right: 1px solid var(--c-dark-3);
}

.showform.second-modal {
	right: 414px;
	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, right 0.3s ease-out;
}

.stream-type-info {
	/* background-color: var(--c-dark-3); */
	padding: 0px;
}

.region-dropdown .dropdown-menu {
	left: -100% !important;
}

.region-flag {
	width: 20px;
}

.modal-logo {
	padding-left: 9px;
}

.stream-type-info h4,
.stream-type-info p {
	cursor: pointer;
}

@media (max-width: 767px) {
	.mobile-header {
		border-radius: 24px 24px 0 0;
		margin-top: 0;
		background-color: var(--c-dark-3);
		border-bottom: 1px solid var(--c-dark-5);
	}

	.hideform.second-modal {
		bottom: -115vh;
		left: 0;
		z-index: 0;
		max-width: 100%;
		transition: opacity 0.3s linear, bottom 0.3s ease-out;
	}

	.showform.second-modal {
		height: auto;
		top: auto;
		bottom: 0;
		left: 0;
		z-index: 1030;
		max-width: 100%;
		transition: opacity 0.3s linear, bottom 0.3s ease-out;
	}

	.modal-logo {
		display: none;
	}

	.modal-title {
		padding: 16px 0;
	}

	.modal-title-style2 {
		display: none;
	}

	.second-modal {
		width: 100%;
		border-left: none;
		border-right: none;
	}

	.btn-close {
		background-color: var(--c-dark-5);
		border-radius: 50%;
		color: var(--c-dark-8);
		height: 32px;
		width: 32px;
	}

	.mt-200 {
		margin-top: 0;
	}

	.stream-item {
		padding: 15px;
	}

	.btn-icon {
		color: var(--c-dark-7);
	}

	:deep( .region-dropdown .dropdown-menu) {
		max-width: 315px;
	}

	:deep(.regions-wrapper) {
		top: -191px;
	}
}

@media (min-width: 768px) and (max-width: 991px) {
	.showform.second-modal {
		right: 100%;
	}
}</style>
